var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { DropdownMenuDivider } from '../dropdown-menu-divider';
import { DropdownMenuGroup } from '../dropdown-menu-group';
import { DropdownMenuListItem } from '../dropdown-menu-list-item';
import { MenuList } from '../../menu';
import { styled } from '../../styled';
export var dropdownMenuListComponentName = 'QuantumDropdownMenuList';
var Root = styled(MenuList, { name: dropdownMenuListComponentName, slot: 'Root' })({});
export var DropdownMenuList = React.forwardRef(function (props, ref) {
    var items = props.items, children = props.children, rootProps = __rest(props, ["items", "children"]);
    var content = items
        ? items.map(function (_a, index) {
            var type = _a.type, itemProps = __rest(_a, ["type"]);
            if (type === 'divider') {
                return React.createElement(DropdownMenuDivider, { key: index });
            }
            if (type === 'group') {
                return React.createElement(DropdownMenuGroup, __assign({ key: index }, itemProps));
            }
            return React.createElement(DropdownMenuListItem, __assign({ key: index }, itemProps));
        })
        : children;
    return (React.createElement(Root, __assign({}, { component: 'div' }, { "aria-orientation": "vertical", disablePadding: true, autoFocus: true, ref: ref }, rootProps), content));
});
